"use client";
import { useState } from "react";
import GoalOddEvenOdds from "../GoalOddEvenOdds";
import CorrectScoresOdds from "../CorrectScoresOdds";
import TotalCornersOdds from "../TotalCornersOdds";
import "./index.scss";

const TAB_IDS = {
  FIRST_TAB: "FIRST_TAB",
  SECOND_TAB: "SECON_TAB",
};

const hasData = (array) => {
  return array && array.length > 0;
};

export default function StakeOtherBetsDropdown({
  goalOddEvenOdds,
  correctScoresOdds,
  totalCornersOdds,
  correctScoresHalfOdds,
  totalCornersHalfOdds,
}) {
  const [activeTab, setActiveTab] = useState(TAB_IDS.FIRST_TAB);
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const selectAndDisplayOdds = (odds) => {
    return odds;
  };
  
  const hasFullMatchData = hasData(goalOddEvenOdds) || hasData(correctScoresOdds) || hasData(totalCornersOdds);
  const hasHalfMatchData = hasData(correctScoresHalfOdds) || hasData(totalCornersHalfOdds);
  const hasAnyData = hasFullMatchData || hasHalfMatchData;
  
  if (!hasAnyData) {
    return null;
  }
  
  return (
    <div className="stake-other-bets-wrapper w-full mx-auto overflow-x-auto rounded-xl border border-[var(--theme-border)] stake-bg-header mt-3">
      <div className="min-w-auto">
        <ul className="inline-flex pt-2 px-1 w-full border-b border-[var(--theme-border)] mb-4 gap-2">
          <li
            className={`flex items-center justify-center px-4 min-w-[5rem] font-semibold py-2 rounded-t transition-colors ${
              activeTab === TAB_IDS.FIRST_TAB
                ? "bg-[var(--stake-active-bg)] text-white"
                : "bg-[var(--theme-bg)] text-[var(--theme-text)] hover:opacity-90"
            }`}
          >
            <button 
              className="bg-transparent border-none text-sm font-semibold cursor-pointer" 
              onClick={() => handleTabClick(TAB_IDS.FIRST_TAB)}
            >
              Cả trận
            </button>
          </li>
          <li
            className={`flex items-center justify-center px-4 font-semibold py-2 rounded-t transition-colors ${
              activeTab === TAB_IDS.SECOND_TAB
                ? "bg-[var(--stake-active-bg)] text-white"
                : "bg-[var(--theme-bg)] text-[var(--theme-text)] hover:opacity-90"
            }`}
          >
            <button 
              className="bg-transparent border-none text-sm font-semibold cursor-pointer"
              onClick={() => handleTabClick(TAB_IDS.SECOND_TAB)}
            >
              Hiệp 1
            </button>
          </li>
        </ul>

        <div className="px-2 pb-2">
          <div
            className={`${
              activeTab === TAB_IDS.FIRST_TAB ? "visible" : "hidden"
            }`}
          >
            <div className="flex flex-col gap-1 p-2">
              {hasData(goalOddEvenOdds) && (
                <GoalOddEvenOdds
                  goalOddEvenOdds={selectAndDisplayOdds(goalOddEvenOdds)}
                />
              )} 
              {hasData(correctScoresOdds) && (
                <CorrectScoresOdds
                  correctScoresOdds={selectAndDisplayOdds(correctScoresOdds)}
                />
              )}
              {hasData(totalCornersOdds) && (
                <TotalCornersOdds
                  totalCornersOdds={selectAndDisplayOdds(totalCornersOdds)}
                />
              )}
            </div>
          </div>
          <div
            className={`${
              activeTab === TAB_IDS.SECOND_TAB ? "visible" : "hidden"
            }`}
          >
            <div className="flex flex-col gap-1 p-2">
              {hasData(correctScoresHalfOdds) && (
                <CorrectScoresOdds
                  correctScoresOdds={selectAndDisplayOdds(correctScoresHalfOdds)}
                />
              )}
              {hasData(totalCornersHalfOdds) && (
                <TotalCornersOdds
                  totalCornersOdds={selectAndDisplayOdds(totalCornersHalfOdds)}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
